var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[_vm._v(_vm._s(_vm.dataHora))])])
}
var staticRenderFns = []

export { render, staticRenderFns }